export * from './auto'



// WEBPACK FOOTER //
// ./src/public/plugins/widget/index.js